import { services } from '../../../../constants/services';
import { getByQuery } from '../../../../utils/api';

export interface IParamasGetInquiryAnalitic {
  startDate?: string,
  endDate?: string,
  channelIds?: any,
  status?: string,
}
export const GetReportInquiryFrequencybyProcedureService = async (params: IParamasGetInquiryAnalitic) => {
  const response: any = await getByQuery<any>(`${services.analytics}/inquiry-frequency-by-procedure`, params);
  return response?.data;
};